<template>
  <div class="pa-0 ma-0 bs-actions">
    <div v-if="calendar_type == 2 || calendar_type == 5">
      <v-row v-if="availiable_limit > 0">
        осталось: {{ availiable_limit }} (ч)
      </v-row>
      <v-row v-else>
        Выделено все доступное время
      </v-row>
    </div>

    <div v-if="small_view">
      <div v-if="edit_mode && add_new && availiable_limit > 0" class="bs-actions__date">
        <v-menu
          ref="date_menu"
          v-model="date_menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="datesActionsV"
              label="Дата или интервал"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            :color="$mainColor"
            show-adjacent-months
            type="date"
            v-model="datesActions"
            landscape
            flat
            class='mt-2'
            locale='ru-RU'
            no-title
            show-current="calendar_current"
            first-day-of-week=1
            :min="calendar_start ? calendar_start : undefined"
            :max="calendar_end ? calendar_end : undefined"
            scrollable
            range>

            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="date_menu = false"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>

        <v-row>
          <v-col
            cols="6"
            sm="6"
            class="pa-0"
          >
            <v-menu
              ref="menu"
              v-model="menu_time"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="start_time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start_time"
                  label="Время начала"
                  prepend-icon="mdi-clock-time-four-outline"
                  :color='$mainColor' 
                  readonly
                  v-bind="attrs"
                  small
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menu_time"
                v-model="start_time"
                full-width
                locale='ru'
                
                scrollable
                :allowed-minutes="allowedStep"
                class="mt-4"
                format="24hr"
                
                :color='$mainColor' 
                @click:minute="$refs.menu.save(start_time)"
              />

            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="6"
            sm="6"
            class="pa-0"
          >
            <v-menu
              ref="menu2"
              v-model="menu_end_time"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="end_time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="end_time"
                label="Время окончания"
                prepend-icon="mdi-clock-time-four-outline"
                :color='$mainColor' 
                readonly
                v-bind="attrs"
                v-on="on"
                small
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="menu_end_time"
              v-model="end_time"
              locale='ru'
              full-width

              :allowed-minutes="allowedStep"
              class="mt-4"
              format="24hr"

              :color='$mainColor' 
              @click:minute="$refs.menu2.save(end_time)"
            />
            </v-menu>
          </v-col>
        </v-row>
      </div>
        
    </div>
    <div v-else>
      <div v-if="edit_mode" class="bs-actions__date">
        <v-date-picker 
          :color="$mainColor"
          show-adjacent-months
          type="date"
          v-model="datesActions"
          landscape
          flat
          class='mt-2'
          full-width
          locale='ru-RU'
          :min="calendar_start ? calendar_start : undefined"
          :max="calendar_end ? calendar_end : undefined"
          no-title
          show-current="calendar_current"
          first-day-of-week=1
          range>
        </v-date-picker>
        <v-row>
          <v-col
            cols="6"
            sm="6"
          >
            <v-menu
              ref="menu"
              v-model="menu_time"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="start_time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start_time"
                  label="Время начала"
                  prepend-icon="mdi-clock-time-four-outline"
                  :color='$mainColor' 
                  readonly
                  v-bind="attrs"
                  small
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menu_time"
                v-model="start_time"
                full-width
                locale='ru'
                
                scrollable
                :allowed-minutes="allowedStep"
                class="mt-4"
                format="24hr"
                
                :color='$mainColor' 
                @click:minute="$refs.menu.save(start_time)"
              />

            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="6"
            sm="6"
          >
            <v-menu
              ref="menu2"
              v-model="menu_end_time"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="end_time"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="end_time"
                label="Время окончания"
                prepend-icon="mdi-clock-time-four-outline"
                :color='$mainColor' 
                readonly
                v-bind="attrs"
                v-on="on"
                small
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="menu_end_time"
              v-model="end_time"
              locale='ru'
              full-width

              :allowed-minutes="allowedStep"
              class="mt-4"
              format="24hr"

              :color='$mainColor' 
              @click:minute="$refs.menu2.save(end_time)"
            />
            </v-menu>
          </v-col>
        </v-row>
      </div>
        
      <div v-else class="bs-actions__date">
        <v-date-picker 
          :color="$mainColor"
          show-adjacent-months
          type="date"
          v-model="datesActions"
          landscape
          flat
          class='mt-2'
          full-width
          locale='ru-RU'
          no-title
          range
          readonly
          :value="calendar_current"
          :show-current="calendar_current"
          first-day-of-week=1
        >
        </v-date-picker>
        <v-row>
          <v-col
            cols="6"
            sm="6"
          >
            <v-text-field
              v-model="current_start"
              label="Время начала"
              prepend-icon="mdi-clock-time-four-outline"
              :color='$mainColor' 
              readonly
              small
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col
            cols="6"
            sm="6"
          >
            <v-text-field
              v-model="current_end"
              label="Время окончания"
              prepend-icon="mdi-clock-time-four-outline"
              :color='$mainColor' 
              readonly
              small
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-card-actions  v-if='add_new && availiable_limit > 0'>
      <v-spacer></v-spacer>
      <div v-if="edit_mode">
        <v-btn 
          small 
          class='pa-2'
          style="width:100%; " 
          color="red" 
          outlined
          :disabled="datesActions.length < 1 ||  start_time === null ||  end_time === null" 
          @click="addInterval()">{{$t('Actions.add_interval')}}
        </v-btn>
      </div>
    </v-card-actions>

    <v-card-actions  v-if='can_edit && !add_new'>
      <v-spacer></v-spacer>
      <div v-if="edit_mode">
        <v-btn color="green darken-1" text @click="prepare_dates(), edit_mode = false">{{ $t('cancel') }}</v-btn>
        <v-btn 
          color="green darken-1" 
          text 
          @click="updateDates()"
          :loading="loaded"
        >
          {{ $t('save') }}
        </v-btn>
      </div>
      <div v-else>
        <v-btn color="green darken-1" text @click="edit_mode = true">Изменить время</v-btn>
      </div>
    </v-card-actions>

  </div>
</template>
<script>
import { mapActions} from 'vuex'
export default {
    props: {
        proposal_id: [String, Number],
        station_id: Number,
        can_edit: Boolean,
        input_dates: Array,
        availiable_limit: Number,
        calendar_id: Number,
        add_new: Boolean,
        small_view: Boolean,
        calendar_type: Number,
        calendar_start: String,
        calendar_end: String,
    },
    mounted() {
    },
    data() {
        return {
            loaded: false,
            datesActions: [],
            end_time: null,
            start_time: null,
            menu_time: false,
            menu_end_time: false,
            calendar_current: null,
            current_start: '',
            current_end: '',
            edit_mode: false,
            date_menu: false,
            temp_arr: [],
            
        }
    },
    computed: {
      datesActionsV() {
        if(this.datesActions.length <= 0)
          return ''

        this.temp_arr = []
        if(this.datesActions.length == 1){
          this.temp_arr[0] = this.datesActions[0]
          this.temp_arr[1] = this.datesActions[0]
        }
        else if(this.datesActions[0] > this.datesActions[1]){
          this.temp_arr[0] = this.datesActions[1];
          this.temp_arr[1] = this.datesActions[0];
        }
        else{
          this.temp_arr[0] = this.datesActions[0];
          this.temp_arr[1] = this.datesActions[1];
        }

        return this.temp_arr[0].split('-').reverse().join('.') + ' - ' + this.temp_arr[1].split('-').reverse().join('.')
      }
    },

    methods: {
        ...mapActions([
          'UPDATE_CALENDAR_REC',
          'ADD_CALENDAR_REC',
        ]),

        allowedStep: m => m % 30 === 0,


        addInterval() {
          var res = this.collect_dates()
          if(res.status == true){
            if(this.calendar_type == 3 || this.calendar_type == 4){
              var args = {
                type: this.calendar_type,
                start_date: res.new_date_time[0],
                finish_date: res.new_date_time[1],
                is_completed: false
              }
              this.loaded = true

              this.ADD_CALENDAR_REC(args)
              .then(res => {
                  this.loaded = false
                  this.$emit('updateParent')
              })
              .catch(() => {
              })
            }
            else{
              var args = {
                type: this.calendar_type,
                proposal_id: this.proposal_id,
                station_id: this.station_id,
                start_date: res.new_date_time[0],
                finish_date: res.new_date_time[1]
              }
              this.loaded = true

              this.ADD_CALENDAR_REC(args)
              .then(res => {
                  this.loaded = false
                  this.$emit('updateParent')
              })
              .catch(() => {
              })
            }
          }
        },

        collect_dates(){
          var start_time = this.start_time ? `${this.start_time}` : `00:00`
          var end_time = this.end_time ? `${this.end_time}` : `00:00`

          if(this.datesActions.length == 1){
            this.datesActions[1] = this.datesActions[0]
          }
          else if(this.datesActions[0] > this.datesActions[1]){
              var t = this.datesActions[0];
              this.datesActions[0] = this.datesActions[1];
              this.datesActions[1] = t;
          }

          if(this.datesActions[1] == this.datesActions[0] && start_time >= end_time){
            this.$messageHelper('Укажите корректный интервал!', 'error', 3000);
            return {status: false}
          }
                
          var new_date_time = [
            this.datesActions[0] + ' ' + start_time,
            this.datesActions[1] + ' ' + end_time
          ]

          var new_start_date = new Date(new_date_time[0])
          var new_end_date = new Date(new_date_time[1])

          var diff = (new_end_date - new_start_date)/ 3600000

          if(diff == 0){
            this.$messageHelper('Укажите корректный интервал!', 'error', 3000);
            return {status: false}
          }

          if(diff > this.availiable_limit){
            this.$messageHelper('Выбранный вами интервал больше доступного лимита времени! (' + this.availiable_limit + 'ч.)', 'error', 3000);
            return {status: false}
          }
          return {status: true, new_date_time: new_date_time}
        },

        updateDates(){
          var res = this.collect_dates()
          if(res.status == true){
            var args = {
              id: this.calendar_id,
              start_date: res.new_date_time[0],
              finish_date: res.new_date_time[1]
            }
            this.loaded = true

            this.UPDATE_CALENDAR_REC(args)
            .then(res => {
                this.loaded = false
                this.edit_mode = false
                this.$emit('updateParent')
            })
            .catch(() => {
                this.loaded = false
            })
          }
        },

        prepare_dates(){
          if(this.add_new){
            this.edit_mode = true
            this.datesActions = []
            this.current_start = ''
            this.current_end = ''
          }
          else{
            var start = this.input_dates[0].split(' ');
            var end = this.input_dates[1].split(' ');

            this.datesActions = []
            this.edit_mode = false
            this.calendar_current = start[0] 
            this.datesActions[0] = start[0]
            this.datesActions[1] = end[0]
            this.start_time = this.current_start = start[1]
            this.end_time = this.current_end = end[1]
          }
        },
    },
    watch: {
      input_dates:{
        handler: function (val, oldVal) { 
          this.prepare_dates()
        },
        deep: true
      },
    },

    beforeMount(){
      this.prepare_dates()
    },
}
</script>
<style>
    .bs-actions {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .bs-actions__text,
    .bs-actions__textarea {
        width: 100%;
        margin-left:0px;
        margin-right:15px;
        /* background-color:rgba(229,115,115,0.4); */
    }

    .bs-actions__text {
        padding: 15px 15px 0 15px;
        /* border: 1px solid red; */
        background-color:rgba(255,255,255,0);
        border-radius:8px;
        margin-top:20px;
    }

    .v-input--selection-controls {
        margin-top: 0;
    }
    .bs-actions__save {
        padding-top: 15px;
        padding-bottom: 15px;
    }
    .date-interval .v-input__slot {
        margin-bottom: 0 !important;
    }
    .date-interval .v-messages {
        display: none !important;
    }
    .bs-actions__date{
        margin-left:0px;
        width:100%;
        background-color:rgba(255,255,255,0.9);
        border-radius:8px;
        padding: 15px 15px 0 15px;
        margin-right:15px;
        margin-top:20px;
    }
</style>